import modal from '../../../../modules/Gull/Framework/modal.js';

const editView = {

	init() {

		// Controleer of er reeds een werknemer id geset is
		if ($('#form-werknemer').data('werknemer_id') == '') {

			// Controleer of er al een werknemer voorkomt met deze geslacht / geboortedatum combi
			$('#geboorte_datum').on('change', function() {
				editView.toggleFormContinue();
			});

			// Controleer of er al een werknemer voorkomt met deze geslacht / geboortedatum combi
			$('#geboorte_datum').on('blur', function() {
				editView.toggleFormContinue();
			});

			// Controleer of er al een werknemer voorkomt met deze geslacht / geboortedatum combi
			$('#geslacht').on('change', function() {
				editView.toggleFormContinue();
			});

			// Verberg suggestieformulier wanneer een nieuwe werknemer wordt ingevoerd
			$('#nieuwe_werknemer').on('click', function() {
				editView.hideFormSuggestion();
			});

		} else {
			// Verberg het suggestieformulier als er nog geen werknemer ID geset is
			editView.hideFormSuggestion();
		}

		// Zet voorletters in juiste format onChange
		$('#voorletters').on('change', function() {
			var val = $(this).val();
			if (val !== '') {
				val = val.toUpperCase().match(/[A-Z]+/g).join('');
				val = val.split('').join('.') + '.';
				$(this).val(val.substring(0, 10));
			}
		});

		// Haal op basis van postcode de adresgegvens op
		$('.postcode-check').on('change', function(e) {
			e.preventDefault();
			var land = $(this).closest('.adres').find('.land').val();
			var postcode = $(this).closest('.adres').find('.postcode').val();
			var huisnummer = $(this).closest('.adres').find('.huisnummer').val();

			var current_element = this;

			// Maak postcode veld alleen verplicht als het om een nederlands adres gaat
			// if (land == 'NL') {
			// 	$(this).closest('.adres').find('.postcode').attr('data-validate', 'required postcode');
			// }

			// Als het volledige adres is ingevuld
			if (land != '' && land == 'NL' && postcode != '' && huisnummer != '') {

				// Haal adresgegevens op
				$.getJSON(window.app.ajaxPath + $('#form-werknemer').data('administratie_relatie_id') + '/' + $('#form-werknemer').data('werknemer_id') + '/postcode-check/' + land + '/' + postcode + '/' + huisnummer + '/', function(data) {
					if (data != false) {
						$(current_element).closest('.adres').find('.plaats').val(data.woonplaats).attr('readonly', true);
						$(current_element).closest('.adres').find('.straat').val(data.straat).attr('readonly', true);
						$(current_element).closest('.adres').find('.postcode-check-niet-gevonden').hide();
					} else {
						$(current_element).closest('.adres').find('.plaats').val('').removeAttr('readonly');
						$(current_element).closest('.adres').find('.straat').val('').removeAttr('readonly');
						$(current_element).closest('.adres').find('.postcode-check-niet-gevonden').hide().removeClass('d-none').show();
					}
				});
			}
		});

		// Maak van de eerste letter van achternaam een hoofdletter
		$('#achternaam').keyup(function() {
			var v = $(this).val();
			$(this).val(v.substr(0, 1).toUpperCase() + v.substr(1));
		});

		// Valideer adres tekstvelden opnieuw wanneer je land aanpast
		$('body').on('change', '.land', function() {
			$('.form-section-woonadres, .form-section-postadres').find('input[type=text]').each(function() {
				if ($(this).val().length > 0) {
					$(this).trigger('blur');
				}
			});
		});

		// Initieer showPostAdres als zelfde_als_woonadres checkbox gewijzgd wordt
		$('input.zelfde_als_woonadres').change(editView.showPostAdres);

		// Initieer showPostAdres on page load
		editView.showPostAdres();

		// Bind permission buttons met changePermission function
		$('[data-toggle=content-modal-change]').on('change', function(event) {
			modal.getModal(event);
		});

		// Bind permission buttons met changePermission function
		$('[data-toggle=content-modal-blur]').on('blur', function(event) {
			var origineleWaarde = $(event.target).attr('data-content-modal-param2');
			var nieuweWaarde = $(event.target).val();
			var datepicker = $('.datepicker-dropdown');
			if ((origineleWaarde !== nieuweWaarde) && (!datepicker.length)) {
				modal.getModal(event);
			}
		});

		// Bind functie om wijziging ongedaan te maken aan button en verberg modal
		$('body').on('click', '#wijzigingOngedaanMaken', function(event) {
			editView.wijzigingOngedaanMaken(event);
			$('#generalModal').modal('toggle');
		});

	},

	toggleFormContinue: function() {

		if ($('#geslacht').val() != '' && $('#geboorte_datum').val() != '') {
			$.getJSON(window.app.ajaxPath + $('#form-werknemer').data('administratie_relatie_id') + '/' + $('#form-werknemer').data('werknemer_id') + '/duplicate-check/' + $('#geboorte_datum').val() + '/' + $('#geslacht').val() + '/', function(data) {
				if (data != false) {

					// Er bestaat reeds een werknemer met deze geboortedatum / geslacht
					$('#form_suggestion').hide().removeClass('d-none').fadeIn();
					$('#form_continue').hide();
					$('.gevonden-werknemers *').remove();
					$.each(data, function(index, val) {
						$('.gevonden-werknemers').append('<p><a href="' + val.url + '">' + val.naam + '</a><br></p>');
					});

					// Als er nog geen werknemer met deze geboortedatum / geslacht is
				} else {

					// Verberg het formulier
					editView.hideFormSuggestion();
				}
			});
		}

	},

	// Verberg eerste deel van formulier en toon tweede deel
	hideFormSuggestion: function() {
		$('#form_suggestion').fadeOut(100, function() {
			$('#form_continue').hide().removeClass('d-none').fadeIn();
		});
	},

	// Functie om postadres te tonen
	showPostAdres: function() {
		if ($('input.zelfde_als_woonadres').is(':checked')) {
			$('div.postadres_fields').addClass('d-none');
			$('div.postadres_fields').find('input,select').each(function() {
				var validate = $(this).attr('data-validate');
				$(this).attr('data-validate', '').attr('data-validate-org', validate);
			});
		} else {
			$('div.postadres_fields').removeClass('d-none');
			$('div.postadres_fields').find('input,select').each(function() {
				var validate = $(this).attr('data-validate-org');
				$(this).attr('data-validate-org', '').attr('data-validate', validate);
			});
		}
	},

	// Functie om wijziging ongedaan te maken op basis van een meegegeven veldnaam en waarde
	wijzigingOngedaanMaken: function(event) {
		var field = $(event.target).data('field');
		var value = $(event.target).data('value');
		$('#' + field).val(value);
	}

};

export default editView;
